import { createReducer } from "@reduxjs/toolkit";

const initialState = {
    loading : false ,
    userProfile : null ,
};

export const userprofileReducer = createReducer(initialState,{

    LoadUserProfileRequest : (state) => {
        state.loading = true ;
    },

    LoadUserProfileSuccess : (state, action) => {
        state.loading = false;
        state.userProfile = action.payload ;
    },

    LoadUserProfileFailure : (state,action) => {
        state.loading = false;
        state.error = action.payload;
    },

    UpdateUserProfileRequest : (state, action) => {
        state.loading = true ;
    },

    UpdateUserProfileSuccess : (state, action) => {
        state.loading = false ;
        state.userProfile = action.payload ;  
    },

    UpdateUserProfileFailure : (state, action) => {
        state.loading = false ;
        state.error = action.payload ;
    }


});